import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { IntegrationsService } from '../../services/integrations.service'
  ;
@Component({
  selector: 'app-modal-image',
  imports: [
    MatIconModule,
    MatDialogModule,
    CommonModule,
    ReactiveFormsModule,
    MatChipsModule,
    FormsModule,
    MatInputModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatSelectModule
  ],
  templateUrl: './modal-image.component.html',
  styleUrl: './modal-image.component.css'
})
export class ModalImageComponent implements OnInit, OnDestroy {

  readonly dialog = inject(MatDialog);
  @Input() dialogRef: MatDialogRef<ModalImageComponent> = inject(MatDialogRef);

  public types: any[] = [
    { value: 'INTEGER', name: "INTEGER" },
    { value: 'STRING', name: "STRING" },
    //{ value: 'BOOLEAN', name: "BOOLEAN" },
  ];

  names: any[] = [
    'NO_PAPER',
    'CONTAINERS_FULL',
    'NOT_WORKING',
    'DOORS_OPEN',
    'SECURITY',
    'STANDBY',
    'ANIMATION_SCAN_BARCODE',
    'ANIMATION_INSERT_PACKAGE',
    'REPEAT_ACTIVITY',
    'ACCEPTING',
    'ACCEPTING_UNSUPPORTED_INFO',
    'ACCEPTING_EMPTY_PACKAGING_INFO',
    'ACCEPTING_FRAUD_INFO',
    'ACCEPTING_PLEASE_WAIT',
    'RECEIPT_PRINTING',
    'THANK_YOU'
  ];

  public editForm: FormGroup = new FormGroup({
    id: new FormControl(0, [Validators.required]),
    integrationId: new FormControl("", [Validators.required]),
    name: new FormControl("", [Validators.required]),
    file: new FormControl(null, [Validators.required]),
    //type: new FormControl("1", [Validators.required]),
    //val: new FormControl("", [Validators.required]),
  });

  constructor(
    public integrationsService: IntegrationsService,

  ) { }

  getMissingNames() {
    if (this.integrationsService.currentIntegration.images === undefined) {
      return this.names;
    } else {
      let filtered = this.names.filter(name => !this.integrationsService.currentIntegration.images.some(image => image.name === name));
      if(this.integrationsService.currentImage.id > 0) {
        filtered.push(this.integrationsService.currentImage.name);    
      } 
      return filtered;
    }
  }

  addImage() {

    if (this.editForm.invalid) {
      return;
    }
    const formData = new FormData();
    formData.append('file', this.editForm.value.file);
    formData.append('name', this.editForm.value.name);
    formData.append('integrationId', this.editForm.value.integrationId);

    this.integrationsService.addImage(formData)
      .subscribe({
        next: (data: any) => {
          console.log("data", data);


          if(data.image) {
            this.integrationsService.currentImage = data.image;
          }
          if(data.integration) {
            this.integrationsService.setCurrentIntegration(data.integration);// = data.integration;
          }
          this.dialogRef.close();
        },
        error: (error: any) => {
          console.log("error", error);
        }
      });
  }
  updateImage() {

    if (this.editForm.invalid) {
      return;
    }

    const formData = new FormData();
    formData.append('file', this.editForm.value.file);
    formData.append('name', this.editForm.value.name);
    formData.append('integrationId', this.editForm.value.integrationId);

    this.integrationsService.updateImage(this.integrationsService.currentImage.id, formData)
      .subscribe({
        next: (data: any) => {
          console.log("data", data);
          this.integrationsService.currentImage = data.image;
          this.integrationsService.setCurrentIntegration(data.integration);// = data.integration;
          this.dialogRef.close();
        },
        error: (error: any) => {
          console.log("error", error);
        }
      });
  }

  onSubmit() {
    //console.log("submit")
    if (this.integrationsService.currentImage.id === 0) {
      //console.log("addImage");
      this.addImage();
    } else {
      //console.log("updateImage");
      this.updateImage();
    }
  }

  ngOnInit(): void {
    console.log("init", this.integrationsService.currentImage);
    this.editForm.patchValue({
      id: this.integrationsService.currentImage.id,
      integrationId: this.integrationsService.currentImage.integrationId,
      name: this.integrationsService.currentImage.name,
      //file: this.integrationsService.currentImage.file
    });

    if (this.integrationsService.currentParam.id > 0) {
      this.editForm.patchValue(this.integrationsService.currentParam);
    } else {
      this.editForm.patchValue({ integrationId: this.integrationsService.currentIntegration.id });
    }

  }

  ngOnDestroy(): void {
    console.log("destroy");
    this.integrationsService.currentImage = { id: 0, integrationId: 0, name: "" };
  }

  checkDisabled() {
    return this.editForm.invalid;
  }

  getTitle() {
    if (this.integrationsService.currentImage.id === 0) {
      return "Dodaj media";
    } else {
      return "Edytuj media";
    }
  }

  getSaveText() {
    if (this.integrationsService.currentImage.id === 0) {
      return "Dodaj";
    } else {
      return "Zapisz";
    }
  }


  fileInputChange(fileInputEvent: any) {
    console.log(fileInputEvent.target.files[0]);

    const file: File = fileInputEvent.target.files[0];
    if (file) {
      const fileName = file.name;
      //const formData = new FormData();
      this.editForm.patchValue({
        file: file
      });

        console.log("file", this.editForm.value.file);
        console.log("form", this.editForm.value);
    }

  }

}
